import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { webSessionAliveCheck } from '../services/serviceAPIHelper';
import { logout } from '../components/Login/loginService';
import { getPalette } from './AppPalette/AppPaletteFactory';
import 'typeface-roboto';
import fetchIntercept from 'fetch-intercept';
import { translate } from 'react-i18next';
import ReactGA from 'react-ga';

import Index from '../cms/Index';
import { getCMSConfiguration, setColorTheming } from '../cms/cmsLib';
import { DialogTitle, Dialog } from 'material-ui';
import { DialogContent } from 'material-ui';
import { DialogContentText } from 'material-ui';
import { DialogActions } from 'material-ui';
import { Button } from 'material-ui';
import { withStyles } from 'material-ui';
import swal from 'sweetalert';

const GAkeys = require('../GAHostToKeys.json');

function isNotConnectUrls(url) {
    return (url.indexOf('reconnect') === -1
        && url.indexOf('token') === -1
        && url.indexOf('login') === -1
        && url.indexOf('recoverpassword') === -1
        && url.indexOf('resetpassword') === -1
        && url.indexOf('locales') === -1 && url.indexOf('masterdata') === -1);
}

//Hook para validar las peticiones antes de que estas salgan
//OLYB2B-297 - checkeo de session alive
fetchIntercept.register({
    request: async function (url, config) {
        //si son las urls del api
        if (url.indexOf(process.env.REACT_APP_API_ROOT) !== -1) {
            //console.time(url);
            ////console.log(">> request");
            ////console.log(url);
            // chequeo si no son las urls de login
            if (isNotConnectUrls(url)) {
                const isalive = await webSessionAliveCheck(false, true).then(isalive => {
                    return isalive;
                });
                //siempre piso el token porque a veces se reconecta el usuario y este
                //config.headers quedo con el viejo token.
                if (config && config.headers) {
                    config.headers['x-access-token'] = localStorage.getItem('token');
                }
                ////console.log(isalive ? "> web session alive > proceed" : "> web session expired > logout");
                if (isalive) {
                    return [url, config];
                } else {
                    logout('Su sesion ha expirado. Por favor vuelva a ingresar.');
                }
            } else {
                return [url, config];
            }
        } else {
            return [url, config];
        }
    },

    requestError: function (error) {
        // Called when an error occurred during another 'request' interceptor call
        ////console.log("requestError", error);
        return Promise.reject(error);
    },

    response: async function (response) {
        // Modify the response object
        if (response.url.indexOf(process.env.REACT_APP_API_ROOT) !== -1) {
            ////console.log(">> response");
            //console.timeEnd(response.url);
            // chequeo si no son las urls de login
            if (isNotConnectUrls(response.url)) {
                //si se desconecto por expiracion del oauth
                if (response.status === 401) {
                    const isalive = await webSessionAliveCheck(false, true).then(isalive => {
                        return isalive;
                    });
                    //pero la web-session esta dentro del rango de no expirar
                    if (!isalive) {
                        ////console.log(">logout");
                        logout('Su sesion ha expirado. Por favor vuelva a ingresar.');
                    }
                } else {
                    //si llego el resultado y no es un-authorized entonces sigue logueado y laburando
                    //extiendo la session.
                    await webSessionAliveCheck(true, false);
                }
                return response;
            } else {
                return response;
            }
        }
        return response;
    },

    responseError: function (error) {
        // Handle an fetch error
        console.error(error);
        return Promise.reject(error);
    }
});

const styles = theme => ({
    main: {
        paddingLeft: '8px'
    }
});
class App extends React.Component {
    constructor() {
        super();
        this.state = {
            alertText: '',
            alertOpen: false,
        };
        let key = null;
        let GAoptions = {};
        //https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/692092941/Google+Analytics
        //OLYB2B-553 OLYB2B-729 - esto se hace asi para evitar el tiempo de configuracion de terra-form y otras variables de entorno
        if (GAkeys.hasOwnProperty(window.location.hostname)) {
            key = GAkeys[window.location.hostname];
        } else {
            // eslint-disable-next-line no-console
            console.warn('Using GA.default key for host ' + window.location.hostname);
            key = GAkeys.default;
        }
        if (key) {
            ReactGA.initialize(key, GAoptions);
        }
        //hack para redireccionar el alert de esta manera.
        let scope = this;
        (function (proxied) {
            window.alert = function () {
                let msj = String(arguments[0]);
                swal('', msj, msj.indexOf('rror') != -1 ? 'error' : 'warning');
                return true;
            };
        })(window.alert);
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error(error, info);
    }
    componentDidMount() {
        console.log('APP READY');
        let cmsconf = getCMSConfiguration();
        setColorTheming(cmsconf);
    }

    startErrorLog() {
        window.onerror = (message, file, line, column, errorObject) => {
            column = column || (window.event && window.event.errorCharacter);
            let stack = errorObject ? errorObject.stack : null;

            //trying to get stack from IE
            if (!stack) {
                stack = [];
                let f = arguments.callee.caller;
                while (f) {
                    stack.push(f.name);
                    f = f.caller;
                }
                errorObject['stack'] = stack;
            }

            //here I make a call to the server to log the error
            // eslint-disable-next-line no-console
            console.error(message);

            //the error can still be triggered as usual, we just wanted to know what's happening on the client side
            return false;
        };
    }
    handleClose = () => {
        this.setState({
            alertOpen: false,
            alertText: ''
        });
    };
    handleOpen = (text) => {
        this.setState({
            alertOpen: true,
            alertText: text
        });
    };

    render() {
        const { t } = this.props;
        const appPalette = getPalette();
        return (
            <MuiThemeProvider theme={appPalette.default}>
                <Index />
                <Dialog open={this.state.alertOpen}
                    onClose={this.handleClose}
                    aria-labelledby="global-alert-dialog-title"
                    aria-describedby="global-alert-dialog-description">
                    <DialogTitle id="global-alert-dialog-title"></DialogTitle>
                    <DialogContent style={{ minWidth: '320px', maxWidth: '640px' }}>
                        <DialogContentText id="global-alert-dialog-description">
                            {this.state.alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" variant="raised" autoFocus onClick={this.handleClose}>
                            {t('HOME.EXIT_MENU')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </MuiThemeProvider>
        );
    }
}
export default translate('translations')(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/components/App.js